import { has } from "../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "title",
                    "description",
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^surveyQuestions\\.[^\\.]+\\.(title|refChoiceType)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^surveyQuestions\\.[^\\.]+\\.questionChoices\\.[^\\.]+\\.(value)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ componentKey }) => {
                return [
                    "SurveyQuestionList",
                    "QuestionChoicesList"
                ].includes(componentKey);
            },
            inputPropField: () => {
                let canCreate = false;
                let canDelete = false;
                return { canCreate, canDelete };
            }
        },
    ];
};
